/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="./search_interfaces.ts"/>
/// <reference path="./solr_search.ts"/>
/// <reference path="./solr_search_collection.ts"/>
/// <reference path="../services.ts"/>

namespace DealerwareWebServices {
    "use strict";

    import DealerwareSearchAliases = DealerwareWebServices.DealerwareSearchAliases;

    export class DealerwareSolrSearchVehicleCollection
        extends DealerwareCollectionSolrSearch
        implements IDealerwareSolrSearchVehicleCollection {

        public static $inject: string[] = [
            '$q',
            '$timeout',
            '$injector',
            'DealerwareVehicleCollection',
            '$dealerwareVehicleStatesData',
            '$dealerwareSearchAliases',
        ];


        constructor (
            public $q : any,
            public $timeout : any,
            public $injector: any,
            public DealerwareVehicleCollection : any,
            public DealerwareVehicleStatesData: any,
            public dealerwareSearchAliases: any
        ) {

            super($q,$timeout);
            this.objectCollection = DealerwareVehicleCollection;

            this.dealerwareSearchAliases.aliasData = this.DealerwareVehicleStatesData.states;

            var allFilter = new DealerwareSolrSearchSmartFilter();
            allFilter.name = "all";
            allFilter.searchProperty = "states";
            allFilter.filters = this.dealerwareSearchAliases.getAliasedItems(allFilter.name);

            allFilter.displayTitleIcon = 'filter';
            allFilter.displayDescription = "Search vehicles in all states";
            var _t = "A filter to search vehicles using the state of the vehicle.";
            _t = _t + "<br/><br />This filter will search for vehicles with the following states:<ul>"
            allFilter.filters.forEach(function(val,idx) {
                _t = _t + "<li>" + val + "</li>";
            });
            _t = _t + "</ul>";
            allFilter.displayTooltip = _t;


            var availableFilter = new DealerwareSolrSearchSmartFilter();
            availableFilter.name = "available";
            availableFilter.searchProperty = "states";
            availableFilter.filters = this.dealerwareSearchAliases.getAliasedItems(availableFilter.name);
            availableFilter.displayTitleIcon = 'filter';

            var rentedFilter = new DealerwareSolrSearchSmartFilter();
            rentedFilter.name = "rented";
            rentedFilter.searchProperty = "states";
            rentedFilter.filters = this.dealerwareSearchAliases.getAliasedItems(rentedFilter.name);
            rentedFilter.displayTitleIcon = 'filter';

            this.searchFilters.add(allFilter);
            this.searchFilters.add(availableFilter);
            this.searchFilters.add(rentedFilter);
        }

        public autoCompleteSearchWithoutFilters(searchArgs?: IDealerwareSolrSearchArgs) : ng.IPromise<{}> {
            var _self = this,
                _deferred = this.$q.defer(),
                _results: any = { data: [] };

            this.objectCollection.solr_search({
                promise: true,
                params: {
                    filter: searchArgs ? searchArgs.searchArgs.search_text : this.searchArgs.searchArgs.search_text,
                    location_id: searchArgs ? searchArgs.locationId : this.searchArgs.locationId,
                    active: searchArgs ? searchArgs.active : this.searchArgs.active
                }
            }).then(
                function(returnValue: any) {
                    _results.data.push.apply(_results.data, returnValue.data);
                    _deferred.resolve(_results);
                },
                function(response: any) { _deferred.reject(response); }
            );

            return _deferred.promise;
        }
    }

    getDealerwareWebServicesModule().service("$dealerwareSolrSearchVehicleCollection", DealerwareSolrSearchVehicleCollection);
}